import { PAYMENT_METHOD_LABELS, PAYMENT_METHODS, type PaymentMethod } from '@kominiarz/shared';
import { ChoiceGroup } from '../form/ChoiceGroup';
import { TextInput } from '../form/TextInput';

const METHOD_CHOICES = PAYMENT_METHODS.map((m) => ({ value: m, label: PAYMENT_METHOD_LABELS[m] }));

/** How and when it was paid (shared by the closing and the quick "paid" dialogs). */
export function PaymentFields({
  method,
  paidAt,
  onMethod,
  onPaidAt,
  error,
}: {
  method: PaymentMethod | null;
  paidAt: string;
  onMethod: (m: PaymentMethod) => void;
  onPaidAt: (d: string) => void;
  error?: string;
}) {
  return (
    <>
      <ChoiceGroup<PaymentMethod> legend="Forma płatności" value={method} options={METHOD_CHOICES} columns={2} onChange={onMethod} error={error} />
      <TextInput type="date" label="Data opłacenia" value={paidAt} onChange={(e) => onPaidAt(e.target.value)} />
    </>
  );
}
